import { AxiosResponse } from 'axios';

import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

export type TechnologyType = {
  createdAt: string;
  id: string;
  name: string;
  updatedAt: string;
  isActive: boolean;
};

export type CreateTechnologyByNameType = {
  name: string;
};

const getAllTechnologies = async (): Promise<AxiosResponse<TechnologyType[]>> => {
  const { data, error } = await supabase
    .from('skills')
    .select('*')
    .order('name', { ascending: true });

  if (error) throw error;

  const mapped = (data || []).map((row: any) => ({
    id: row.id,
    name: row.name,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
    isActive: true,
  }));

  return asResponse(mapped);
};

const createTechnologyByName = async (
  params: CreateTechnologyByNameType
): Promise<AxiosResponse<TechnologyType>> => {
  const { data, error } = await supabase
    .from('skills')
    .insert({ name: params.name })
    .select()
    .single();

  if (error) throw error;

  return asResponse({
    id: data.id,
    name: data.name,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    isActive: true,
  });
};

export default {
  getAllTechnologies,
  createTechnologyByName,
};
